import ManagedEntity from '../../n2/data/ManagedEntity.js'

export default class User extends ManagedEntity {
    constructor(userDataSource) {
        super(userDataSource, false)
    }

    isLoggedIn() {
        return this.entity.id !== 0
    }

    async login(email, password, token) {
        try {
            this.clearLastAction()
            this.entity = await this.getDataSource().callCollectionCommand('login', email, password, token || '')
        } catch (ex) {
            this.handleException(ex)
        } finally {
            this.updateComputed()
        }
    }

    async logout() {
        this.clearLastAction()
        await this.getDataSource().callEntityCommand(this.entity.id, 'logout')
        this.entity = { id: 0 }
        this.updateComputed()
    }

    getDisplayName() {
        const user = this.getEntity()
        return user ? (user.firstName + ' ' + user.lastName) : 'Unbekannt'
    }

    updateComputed() {
        super.updateComputed()
        this.permissions = {}
        for (const permission of this.getEntity().permissions || []) {
            this.permissions[permission] = true
        }
    }

    hasPermission(permission) {
        return permission && this.permissions && Boolean(this.permissions[permission])
    }

    hasAnyPermission(prefix) {
        return prefix && this.permissions && Boolean(Object.keys(this.permissions).find(p => p.startsWith(prefix)))
    }
}
